import { assign } from "xstate";
import { track } from "../../actions";
export const priceScreenState = {
    entry: [track],
    on: {
        BACK: "estimation",
        NEXT: "information",
        SET_PRODUCT_ID: {
            actions: assign({
                selectedProductId: (_ctx, event) => event.selectedProductId,
            }),
        },
        SET_ADDITIONAL_PRODUCTS: {
            actions: assign({
                additionalProducts: (_ctx, event) => event.additionalProducts,
            }),
        },
        SET_PRODUCT_TYPE: {
            actions: assign({
                productType: (_ctx, event) => event.productType,
            }),
        },
        SET_START_DATES: {
            actions: assign({
                startDates: (_ctx, event) => event.startDates,
            }),
        },
        SET_FACILITY: {
            actions: assign({
                facility: (_ctx, event) => event.facility,
            }),
        },
        SET_REQUIRES_LIME_PURCHASE: {
            actions: assign({
                requiresLimePurchase: (_ctx, event) => event.requiresLimePurchase,
            }),
        },
        SET_FACILITY_INFORMATION: {
            actions: assign({
                facilityInformation: (context, event) => event.facilityInformation,
            }),
        },
        SET_PERSON: {
            actions: assign({
                person: (context, event) => event.person,
            }),
        },
        SET_ZIP_CODE: {
            actions: "setZipCode",
        },
    },
};
